import axios from "axios";
import dayjs from "dayjs";
import { store } from "../../App";

const CREATE = "/purchases-activity/create";
const UPDATE = "/purchases-activity/update";

export const createPurchase = async (data) => {
  try {
    let res;
    if (data._id) {
      res = await axios.put(UPDATE + `/${data._id}`, data);
    } else {
      res = await axios.post(CREATE, data);
    }

    store.dispatch({
      type: data._id ? "UPDATE_PURCHASE_ACTIVITY" : "CREATE_PURCHASE_ACTIVITY",
      data: res.data.data,
    });
  } catch (e) {
    throw e;
  }
};
export const makePurchase = async (purchase, userType) => {
  try {
    let res = await axios.post('/purchases-activity/make-purchase', { purchase, userType });

    store.dispatch({
      type: "CREATE_PURCHASE_ACTIVITY",
      data: res.data.data,
    });
  } catch (e) {
    throw e;
  }
};

export const fetchPurchasesActivity = async () => {
  try {
    const centerId = JSON.parse(localStorage.getItem("centerId")).centerId;

    const res = await axios.get(
      `/purchases-activity?centerId=${centerId}&startDate=${dayjs().format(
        "YYYY-MM-DD"
      )}`
    );
    store.dispatch({ type: "FETCH_PURCHASES_ACTIVITY", data: res.data });
  } catch (e) {
    console.log(e);
    throw e;
  }
};
